// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d0-3";
export var flatBottomCorners = "_d0-5";
export var productImage = "_d0-0";
export var quantityContainer = "_d0-2";
export var quantityHeader = "_d0-6";
export var tooltip = "_d0-1";
export var wrapAndEllipsesOverflow = "_d0-4";